import {getBaseStickyHeaderHeight} from '@github-ui/sticky-css'
import {useEffect, useLayoutEffect, useState} from 'react'

/**
 * Hook to find a DOM element by selector and track its bottom position.
 * Uses useLayoutEffect for initial query (before paint) and ResizeObserver for updates.
 */
export function useSelectorBottomPosition(selector: string): number {
  const [bottom, setBottom] = useState(0)

  // Initial query - runs synchronously before paint
  useLayoutEffect(() => {
    const element = document.querySelector<HTMLElement>(selector)
    if (element) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setBottom(element.getBoundingClientRect().bottom)
    }
  }, [selector])

  // ResizeObserver for subsequent updates
  useEffect(() => {
    const element = document.querySelector<HTMLElement>(selector)
    if (!element) return

    const observer = new ResizeObserver(() => {
      // Defer layout read to idle time for INP optimization
      // eslint-disable-next-line compat/compat -- we polyfill for safari
      window.requestIdleCallback(() => {
        setBottom(element.getBoundingClientRect().bottom)
      })
    })

    observer.observe(element)
    return () => {
      observer.unobserve(element)
      observer.disconnect()
    }
  }, [selector])

  return bottom
}

export const useSiteHeaderHeight = () => {
  const appHeaderBottom = useSelectorBottomPosition('.AppHeader')
  const stickyHeaderBottom = useSelectorBottomPosition('.primary-viewer #issue-viewer-sticky-header')
  const notificationShelfHeight = getBaseStickyHeaderHeight()

  return appHeaderBottom > stickyHeaderBottom ? appHeaderBottom + notificationShelfHeight : stickyHeaderBottom
}
